/**
 * @param {File} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */

export type GetCroppedImgProps = {
  image: HTMLImageElement;
  imageUrl: string;
  fileType: string;
  crop: any;
  fileName: string;
  maxWidth: number;
  maxHeight: number;
};

export const getCroppedImg = async ({
  image,
  fileType,
  crop,
  fileName,
  maxWidth,
  maxHeight,
}: GetCroppedImgProps) => {
  // Convertir le crop en pixels natifs selon l'unite
  let srcX: number;
  let srcY: number;
  let srcWidth: number;
  let srcHeight: number;

  if (crop.unit === "%") {
    srcX = (crop.x / 100) * image.naturalWidth;
    srcY = (crop.y / 100) * image.naturalHeight;
    srcWidth = (crop.width / 100) * image.naturalWidth;
    srcHeight = (crop.height / 100) * image.naturalHeight;
  } else {
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    srcX = crop.x * scaleX;
    srcY = crop.y * scaleY;
    srcWidth = crop.width * scaleX;
    srcHeight = crop.height * scaleY;
  }

  let dstWidth = srcWidth;
  let dstHeight = srcHeight;

  if (dstWidth > maxWidth) {
    const ratio = maxWidth / dstWidth;
    dstWidth = maxWidth;
    dstHeight *= ratio;
  }

  if (dstHeight > maxHeight) {
    const ratio = maxHeight / dstHeight;
    dstHeight = maxHeight;
    dstWidth *= ratio;
  }

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = dstWidth;
  canvas.height = dstHeight;

  if (ctx && fileType !== "image/png") {
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, dstWidth, dstHeight);
  }

  ctx?.drawImage(
    image,
    srcX,
    srcY,
    srcWidth,
    srcHeight,
    0,
    0,
    dstWidth,
    dstHeight
  );

  return new Promise((resolve, reject) => {
    try {
      canvas.toBlob(
        (blob) => resolve(new File([blob as Blob], fileName)),
        fileType,
        fileType === "image/png" ? undefined : 0.8
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject();
    }
  });
};

export default getCroppedImg;
